import React from 'react';
import axios from 'axios'
import { Table, Input, Button,Collapse,Popover,Popconfirm,message,Spin,Tabs } from 'antd';
import Highlighter from 'react-highlight-words';
import Icon from '@ant-design/icons';
import { SearchOutlined,DeleteOutlined,FundViewOutlined,LoadingOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import * as serverconfig from '../serverconn'
import LicenceCommodityForm from '../components/CommodityForm';
import CommodityUpdateForm from '../components/CommodityUpdateForm';
import CommodityGroupList from './LicenceCommodityGroups';

var CryptoJS = require("crypto-js");

const { Panel } = Collapse;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

function callback(key) {
  console.log(key);
}
const { TabPane } = Tabs;


var token= ''
var bizuserid= ''


class LicenceCommodities_All extends React.Component {
  state = {
    searchText: '',
    searchedColumn: '',
    licence_commodities: [],
    datarequested:true,

  };

  componentDidMount(){
    this.comp_reloaded()
    
}

comp_reloaded=()=>{

  if(localStorage.getItem("token")){
     token= localStorage.getItem("token")
  }else{
     token= ''
  }

  if(localStorage.getItem("bizuserid")){
    bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
 }else{
    bizuserid= ''
 }

  axios.defaults.headers={
    "Content-Type":"application/json",
    Authorization:`Token ${token}`
  }

  axios.get(serverconfig.backendserverurl+`/api/licence_commodities/`)
  .then(res => {
      this.setState({
          licence_commodities:res.data
      })

      this.setState({datarequested:false})


  })



}



getColumnSearchProps = dataIndex => ({
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div style={{ padding: 8 }}>
      <Input
        ref={node => {
          this.searchInput = node;
        }}
        placeholder={`Search ${dataIndex}`}
        value={selectedKeys[0]}
        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
        onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
        style={{ width: 188, marginBottom: 8, display: 'block' }}
      />
      <Button
        type="primary"
        onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
        icon={<SearchOutlined />}
        size="small"
        style={{ width: 90, marginRight: 8 }}
      >
        Search
      </Button>
      <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
        Reset
      </Button>
    </div>
  ),
  filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
  onFilter: (value, record) =>
    record[dataIndex]
      .toString()
      .toLowerCase()
      .includes(value.toLowerCase()),
  onFilterDropdownVisibleChange: visible => {
    if (visible) {
      setTimeout(() => this.searchInput.select());
    }
  },
  render: text =>
    this.state.searchedColumn === dataIndex ? (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text.toString()}
      />
    ) : (
      text
    ),
});

handleSearch = (selectedKeys, confirm, dataIndex) => {
  confirm();
  this.setState({
    searchText: selectedKeys[0],
    searchedColumn: dataIndex,
  });
};

handleReset = clearFilters => {
  clearFilters();
  this.setState({ searchText: '' });
};



  render() {
    const columns = [
    
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'id',
        ...this.getColumnSearchProps('name'),
      },

      {
        title: 'Group Name',
        dataIndex: 'commodity_groupname',
        key: 'id',
        ...this.getColumnSearchProps('commodity_groupname'),
      },
      {
        title: 'Code',
        dataIndex: 'code',
        key: 'id',
      },
      {
        title: 'Description',
        dataIndex: 'description',
        key: 'id',
      },
      
    ];

    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
              <Spin size="large">
                <div className="content" />
              </Spin>      
         </div>
      )

    }else{
      return(
        <div>
          


            <Tabs
            defaultActiveKey="001121"
            onChange={() => {}}
            tabPosition={'top'}
          >

             <TabPane tab="Commodities " key="001121">
             <h3>All Commodities</h3>

              <Table 
                columns={columns} 
                scroll={{ x: 1000 }}
                pagination={{showQuickJumper:true,showSizeChanger:true }}
                dataSource={this.state.licence_commodities}
                bordered
                
                expandable={{
                  expandedRowRender: (record) =>{
                      return (
                        <div>
                          <CommodityUpdateForm comm_ID={record.id} 
                          onRefresh={this.comp_reloaded} 
                          />

                        </div>
                      );
                  } ,
                  rowExpandable: (record) => true,
                  onExpand:(condition,record)=>{
                  },
                }}
                />
                
                <br />
                <Collapse defaultActiveKey={['0']} onChange={()=>{}}>
                <Panel header="Create New Commodity" key="1">

                  <LicenceCommodityForm onRefresh={this.comp_reloaded}/>

                </Panel>
                </Collapse>

              </TabPane>

              <TabPane tab="Commodity Groups " key="001111121">
                <CommodityGroupList onRefresh={this.comp_reloaded}  />
              </TabPane>

              </Tabs>

        </div>
    )

    }

   
  }
}

export default LicenceCommodities_All; 
